import { translate } from 'infras/i18n';
import {
  ResourceListItem,
  ResourceTagItem,
} from 'presentations/api/schema/resources';
import {
  resourceCategoryPath,
  resourceListPath,
  resourceTagPath,
} from 'presentations/routes/path';
import { setBreadcrumbs } from 'presentations/views/helpers/breadcrumbs';
import { useContext, useEffect, useState } from 'react';
import { ServicePortalContext } from 'presentations/reducers/ServicePortal';
import searchInsights from 'search-insights';
import Cookie from 'js-cookie';

export interface Props {
  tag: ResourceTagItem | null;
  category: string | null;
  resources: ResourceListItem[];
}

export const useResourceListPage = (props: Props) => {
  const { state: serviceState } = useContext(ServicePortalContext);
  const viewer = serviceState.viewer;

  useEffect(() => {
    if (!serviceState.isInitialized) {
      return;
    }
    if (
      !process.env['ALGOLIA_APPLICATION_ID'] ||
      !process.env['ALGOLIA_SEARCH_ONLY_BLOG_SCOPED_API_KEY']
    ) {
      return;
    }
    searchInsights('init', {
      appId: process.env['ALGOLIA_APPLICATION_ID'],
      apiKey: process.env['ALGOLIA_SEARCH_ONLY_BLOG_SCOPED_API_KEY'],
    });
    searchInsights('viewedObjectIDs', {
      userToken: viewer ? viewer.uid : `anonymous-${Cookie.get('uuid')}`,
      index: 'BlogPost',
      eventName: 'View BlogPost List',
      objectIDs: props.resources.map((r) => String(r.id)),
    });
  }, [serviceState.isInitialized, props.resources]);

  const breadcrumbs = [];
  breadcrumbs.push({
    title: translate('breadcrumbs.Resource'),
    link: resourceListPath(),
  });
  if (props.category) {
    breadcrumbs.push({
      title: translate(`resource.category.${props.category}`),
      link: resourceCategoryPath({ category: props.category }),
    });
  }
  if (props.tag) {
    breadcrumbs.push({
      title: props.tag.name,
      link: resourceTagPath({ tag: props.tag.slug }),
    });
  }
  const routes = setBreadcrumbs(breadcrumbs);
  let categoryName = null;
  if (props.category) {
    categoryName = translate(`resource.category.${props.category}`);
  }

  return {
    state: {
      viewer,
      routes,
      categoryName,
    },
    actions: {},
  };
};
